<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useArrowsAiAssistants } from 'dashboard/composables/useArrowsAiAssistants';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import AssistantForm from './AssistantForm.vue';

const emit = defineEmits(['close', 'created']);
const { t } = useI18n();
const { createAssistant, canCreateAssistant, createLimit } =
  useArrowsAiAssistants();
const dialogRef = ref(null);

const handleSubmit = async payload => {
  if (!canCreateAssistant.value) {
    useAlert(t('ARROWS_AI.SWITCHER.LIMIT', { count: createLimit.value }));
    return;
  }

  if (!payload.name.trim() || !payload.description.trim()) {
    useAlert(t('ARROWS_AI.ASSISTANTS.CREATE.ERROR'));
    return;
  }

  try {
    const assistant = await createAssistant(payload);
    if (!assistant) {
      useAlert(t('ARROWS_AI.SWITCHER.LIMIT', { count: createLimit.value }));
      return;
    }
    useAlert(
      t('ARROWS_AI.ASSISTANTS.CREATE.SUCCESS', { name: assistant.name })
    );
    dialogRef.value.close();
    emit('created', assistant);
  } catch (error) {
    useAlert(error.message || t('ARROWS_AI.SETTINGS.ERROR'));
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('ARROWS_AI.ASSISTANTS.CREATE.TITLE')"
    :description="t('ARROWS_AI.ASSISTANTS.CREATE.DESCRIPTION')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    @close="emit('close')"
  >
    <AssistantForm
      :submit-label="t('ARROWS_AI.CREATE')"
      @submit="handleSubmit"
      @cancel="dialogRef.close()"
    />
    <template #footer />
  </Dialog>
</template>
